module.exports = __webpack_public_path__ + "static/media/copyForward.dd9eef3e.svg";